
import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router } from '@angular/router';
import { Alert } from 'selenium-webdriver';
import { UserserviceService } from '../userservice.service';

@Component({
  selector: 'app-payment-responce-landing',
  templateUrl: './payment-responce-landing.component.html',
  styleUrls: ['./payment-responce-landing.component.scss']
})
export class PaymentResponceLandingComponent implements OnInit {

    standardresponcearraykeys :any[]= [
      "E000" ,
      "E001" , 
      "E002" , 
      "E003" , 
      "E004" , 
      "E005" , 
      "E006" , 
      "E007" ,
      "E008" , 
      "E009" , 
      "E0031"  , 
      "E0032"  , 
      "E0033"  , 
      "E0034"  , 
      "E0035"  , 
      "E0036"  , 
      "E0037" , 
      "E0038" , 
      "E0039" , 
      "E00310", 
      "E00311", 
      "E00312", 
      "E00313", 
      "E00314", 
      "E00315", 
      "E00316",
      "E00317", 
      "E00318", 
      "E00319", 
      "E00320", 
      "E00321", 
      "E00322", 
      "E00323", 
      "E00324",
      "E00325",
      "E00326", 
      "E00327",
      "E00328", 
      "E00329",
      "E00330", 
      "E00331",
      "E00332",
      "E00333", 
      "E00334", 
      "E00335",
      "E0801" ,
      "E0802" , 
      "E0803" , 
      "E0804" , 
      "E0805" ,
      "E0806" ,
      "E0807" ,
      "E0808" ,
      "E0809" , 
      "E0810" , 
      "E0811" , 
      "E0812" ,
      "E0813" ,
      "E0814" ,
      "E0815" ,
      "E0816" ,
      "E0817" ,
      "E0818" ,
      "E0819" ,
      "E0820" ,
      "E0821" , 
      "E0822" ,
      "E0823" ,
      "E0824" ,
      "E0825" ,
      "E0826" ,
      "E0827" ,
      "E0828" ,
      "E0829" ,
      "E0830" ,
      "E0831" , 
      "E0832" , 
      "E0833" ,
      "E0834" ,
      "E0835" ,
      "E0836" ,
      "E0837" , 
      "E0838" ,
      "E0839" ,
      "E0840" ,
      "E0841" , 
      "E0842" ,
      "E0843" ,
      "E0844" ,
      "E0845" , 
      "E0846" ,
      "E0847" ,
      "E0848" ,
      "E0849" ,
      "E0850" ,
      "E0851" , 
      "E0852" ,
      "E0853" ,
      "E0854" ,
      "E0855" ,
      "E0856" ,
      "E0857" , 
      "E0858" , 
      "E0859" , 
      "E0860" ,
      "E0861" ,
      "E0862" ,
      "E0863" ,
      "E0864" 
    ];
    standardresponcearrayvalues :any[]= [ 
      'Payment Successful',
      'Unauthorized Payment Mode',
      'Unauthorized Key',
      'Unauthorized Packet',
      'Unauthorized Merchant',
      'Unauthorized Return URL',
      'Transaction Already Paid, Received Confirmation from the Bank, Yet to Settle the transaction with the Bank',
      'Transaction Failed', 
      'Failure from Third Party due to Technical Error',
      'Bill Already Expired',
      'Mandatory fields coming from merchant are empty',
      'Mandatory fields coming from database are empty',
      'Payment mode coming from merchant is empty',
      'PG Reference number coming from merchant is empty',
      'Sub merchant id coming from merchant is empty',
      'Transaction amount coming from merchant is empty',
      'Payment mode coming from merchant is other than 0 to 9',
      'Transaction amount coming from merchant is more than 9 digit length',
      'Mandatory value Email in wrong format',
      'Mandatory value mobile number in wrong format',
      'Mandatory value amount in wrong format',
      'Mandatory value Pan card in wrong format',
      'Mandatory value Date in wrong format',
      'Mandatory value String in wrong format',
      'Optional value Email in wrong format',
      'Optional value mobile number in wrong format', 
      'Optional value amount in wrong format',
      'Optional value pan card number in wrong format',
      'Optional value date in wrong format',
      'Optional value string in wrong format',
      'Request packet mandatory columns is not equal to mandatory columns set in enrolment or optional columns are not equal to optional columns length set in enrolment',
      'Reference Number Blank',
      'Mandatory Columns are Blank',
      'Merchant Reference Number and Mandatory Columns are Blank', 
      'Merchant Reference Number Duplicate', 
      'Sub merchant id coming from merchant is non numeric',
      'Cash Challan Generated', 
      'Cheque Challan Generated',
      'NEFT Challan Generated', 
      'Transaction Amount and Mandatory Transaction Amount mismatch in Request URL',
      'UPI Transaction Initiated Please Accept or Reject the Transaction', 
      'Challan Already Generated, Please re-initiate with unique reference number', 
      'Referer value is null / invalid Referer',
      'Value of Mandatory parameter Reference No and Request Reference No are not matched',
      'Payment has been cancelled',
      'FAIL',
      'User Dropped',
      'Canceled by user',
      'User Request arrived but card brand not supported',
      'Checkout page rendered Card function not supported', 
      'Forwarded / Exceeds withdrawal amount limit',
      'PG Fwd Fail / Issuer Authentication Server failure', 
      'Session expiry / Failed Initiate Check, Card BIN not present', 
      'Reversed / Expired Card',
      'Unable to Authorize',
      'Invalid Response Code or Guide received from Issuer',
      'Do not honor', 
      'Invalid transaction', 
      'Not Matched with the entered amount',
      'Not sufficient funds', 
      'No Match with the card number',
      'General Error',
      'Suspected fraud', 
      'User Inactive', 
      'ECI 1 and ECI6 Error for Debit Cards and Credit Cards',
      'ECI 7 for Debit Cards and Credit Cards',
      'System error. Could not process transaction', 
      'Invalid 3D Secure values', 
      'Bad Track Data', 
      'Transaction not permitted to cardholder', 
      'Rupay timeout from issuing bank', 
      'OCEAN for Debit Cards and Credit Cards',
      'E-commerce decline',
      'This transaction is already in process or already processed',
      'Issuer or switch is inoperative', 
      'Exceeds withdrawal frequency limit',
      'Restricted card',
      'Lost card', 
      'Communication Error with NPCI', 
      'The order already exists in the database', 
      'General Error Rejected by NPCI', 
      'Invalid credit card number',
      'Invalid amount',
      'Duplicate Data Posted',
      'Format error', 
      'SYSTEM ERROR',
      'Invalid expiration date',
      'Session expired for this transaction', 
      'FRAUD - Purchase limit exceeded', 
      'Verification decline',
      'Compliance error code for issuer', 
      'Caught ERROR of type:[ System.Xml.XmlException ] . strXML is not a valid XML string', 
      'Incorrect personal identification number', 
      'Stolen card', 
      'Transaction timed out, please retry', 
      'Failed in Authorize - PE',
      'Cardholder did not return from Rupay', 
      'Missing Mandatory Field(s)The field card_number has exceeded the maximum length of', 
      'Exception in CheckEnrollmentStatus: Data at the root level is invalid. Line 1, position 1.', 
      'CAF status = 0 or 9', 
      '412',
      'Allowable number of PIN tries exceeded',
      'No such issuer',
      'Invalid Data Posted',
      'PREVIOUSLY AUTHORIZED',
      'Cardholder did not return from ACS', 
      'Duplicate transmission', 
      'Wrong transaction state', 
      'Card acceptor contact acquirer'
    ];
  obj:any = {}
  resmsg: any;
  paymentSuccess!:boolean;
  rescode!: any;   
  resmsgtoshow:string="";
  studData: any;
  statusnotok: boolean=false;
  payment_status: string="";
  resmsg1: string="";
  proccessing: boolean=false;
  freshpayment:boolean=false;
  constructor(private service:UserserviceService ,public router: Router,private route: ActivatedRoute) { 

    
  }

  ngOnInit(): void {
    this.getStudDetail();
    this.proccessing=true;

    if(sessionStorage.getItem('roleid')=="1"){  
      // if(this.statusnotok){
          setTimeout(()=>{
            if(!sessionStorage.getItem("loggeduser") || sessionStorage.getItem("loggeduser")==null ){
              this.router.navigate(['/dashboard']);
             // sessionStorage.clear();
            }
            else{
               this.route.params.subscribe(params => {
                   this.rescode = String(params['code']);
                   // alert(this.rescode);
               });
              //  if(sessionStorage.getItem('flgrep')!="true" || sessionStorage.getItem('flgrep')!=null){ 
                      
              //   }//flgrep 
               if(this.studData.request_status!="Submitted"){  
                alert("Your Request is Not registred yet, \n Please submit reuest.");
                this.studData="";
                this.statusnotok=true;
                sessionStorage.setItem('flgrep','false');
                this.router.navigate(['/dashboard']);
              }//submit status check  

              // if(this.studData.payment_status != "" ||(sessionStorage.getItem('flgrep')!="true" || sessionStorage.getItem('flgrep')!=null){ 
              //   alert("Your Request is already registred , Please check Status");
              //   this.studData="";
              //   this.statusnotok=true;
              //   sessionStorage.setItem('flgrep','false');
              //   this.router.navigate(['/dashboard']);
              //    }            
              else if(sessionStorage.getItem('flgrep')==="true"){ 
                this.statusnotok=false;   
                this.freshpayment=true;   
                let curpaystatus=this.rescode;
                sessionStorage.setItem('flgrep',"false");
               for(var i = 0; i < this.standardresponcearraykeys.length; i++){
                 this.obj[this.standardresponcearraykeys[i]] = this.standardresponcearrayvalues[i];
               }
               if(this.rescode=="E000" || this.rescode=="000"){
                 this.paymentSuccess=true;
                 this.resmsg=  this.obj[curpaystatus];
                 this.resmsg1= "Your Request is Submitted, Board will inform status of request time to time!  \n Kindly submit all documents (as mentioned) to the Board along with Application Form.";
                 
               }
               else{
                 this.paymentSuccess=false;
                 this.resmsg=  this.obj[curpaystatus];
                }
                // console.log(this.obj[curpaystatus]);
                // sessionStorage.removeItem('flgrep');
                
                this.updatepaymentstatus(); 
                
                 }            
              else {
                alert("Your Request is already registred , Please check Status");
                this.studData="";
                this.statusnotok=true;
                sessionStorage.setItem('flgrep',"false");
                this.router.navigate(['/dashboard']);
              }
            }  
            this.proccessing=false;
          },1000); 
      // }            
      }
      else{
        this.router.navigate(['/dashboard']);
      }
    
    
  }


  getStudDetail(){
    let getstud:{ user_id:any,email_address:any}={
      user_id: sessionStorage.getItem('loggeduserid'),
      email_address: sessionStorage.getItem('loggeduser')

    };
      this.service.post('/Student_module/getregistration',getstud).subscribe((res:any)=>{
        if(res.status=="success"){          
            this.studData=res.Data[0];      
        }
          else{
            this.studData="";
            alert("Page is having problem in loading, Please retry!")
            this.router.navigate(['/dashboard']);

          }
      });
    //get student deatils in studData variable   
  }// end getstudData()

    //update status according to respnce
    updatepaymentstatus(){
      if(this.paymentSuccess){
        this.payment_status="Paid";
      }
      else{
        this.payment_status="Unpaid";
      }
      let paystatus: { user_id:any,transaction_id:any,payment_status:any,payment_status_remark:any}={
        user_id: sessionStorage.getItem('loggeduserid'),
        transaction_id:this.studData.transaction_id,
        payment_status: this.payment_status,
        payment_status_remark:this.resmsg
      };
        this.service.post('/Icicipayment/updatepaymentstatus',paystatus).subscribe((res:any)=>{
          if(res.status=="success"){
              alert("Payment Status Updated, Please check your Status time to time. Kindly submit all documents (as mentioned) to the Board along with Application Form.");
            }
          else{
            alert("Payment status NOT Updated, Please wait for next instruction from board!");           
          }
            
        });
      

    }

}


      